import React, {useState} from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import validator from 'validator';
import {forgotRequest} from "../../../../requests/auth/authRequests";
import {useDispatch} from "react-redux";
import {
    setRequestError,
    setSuccessRequest,
    startLoadingAction,
    stopLoadingAction
} from "../../../../reducers/requestUIReducer";
import {useTranslation} from "react-i18next";

export default function ForgotDialog({showForgotDialog,setForgotState,serverErrorCallback}) {

    const initialState = {
        email:'',
        validCredentials:false
    }

    const dispatch = useDispatch()
    const [state, setState] = useState(initialState);
    const {email,validCredentials} = state;
    const { t } = useTranslation();

    const handleRecoverPassword = () => {
        dispatch(startLoadingAction())
        forgotRequest({mail:email},(data,err)=>{
            dispatch(stopLoadingAction())
            if(!err){
                dispatch(setSuccessRequest(t('forgot.success')));
            }else{
                switch (data.status) {
                    case 404:
                        dispatch(setRequestError(t('forgot.not_user_found')))
                        break;
                    case 400:
                        dispatch(setRequestError(t('forgot.invalid_email')));
                        break;
                    case 500:
                        serverErrorCallback();
                        break;
                    default:
                        dispatch(setRequestError(t('forgot.unknown')));
                        break;
                }
            }
            setState(initialState);
            setForgotState( oldState => ({...oldState,showForgotDialog:false}));
        })
    };

    const handleEmail =( event)=>{
        const value = event.target.value;
        setState({email: value,validCredentials:validator.isEmail(value)});
    };

    const handleClose = ()=>{
        setState(initialState);
        setForgotState( oldState => ({...oldState,showForgotDialog:false}));
    }

    return (
        <Dialog open={showForgotDialog} onClose={handleClose} aria-labelledby="form-dialog-title">
            <DialogTitle id="form-dialog-title">{t('forgot.forgot')}</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {t('forgot.enter_email')}
                </DialogContentText>
                <TextField
                    label={t('forgot.email')} variant="outlined"
                    required autoComplete="email" autoFocus fullWidth  margin="normal"
                    onChange={handleEmail} value={email}
                />
            </DialogContent>
            <DialogActions>
                <Button
                    disabled={!validCredentials}
                    onClick={handleRecoverPassword} color="primary">
                    {t('forgot.reset_password')}
                </Button>
            </DialogActions>
        </Dialog>

    );
}